var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-progress',{attrs:{"max":100}},[_c('b-progress-bar',{attrs:{"value":_vm.percentage,"label":_vm.formattedProgressBarText,"variant":_vm.barVariant}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }